import type { RecordOfMatchEntity } from 'app/lib/betting/betting-entities';

export const getIsValidMatchForTimeFilter = (
  match: RecordOfMatchEntity,
  dateWithFilter: number,
) => {
  const matchStartDate = match.startDate && new Date(match.startDate)?.getTime();

  return Boolean(matchStartDate && matchStartDate < dateWithFilter);
};
